import React, { Component } from "react";
import "../../css/toastView.css";
 
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
 
import "react-tabs/style/react-tabs.css";
import "../../css/events.css";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
 

 
const icon1 = "https://winpeforum.com/assets/elements/AishwaryaJaishankar.jpg";
const icon2 = "https://winpeforum.com/assets/elements/NandikaPradeep.png";
const icon3 = "https://winpeforum.com/assets/elements/SunithaViswanathan.jpg";
const icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
const icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
const icon4 = "https://winpeforum.com/assets/elements/Lizzie.png";

let duration = 400;





const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

class WinPEEdge extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     isShow: false,
  //     activeItem: {},
  //   };
  // }

  // togglePopUp = (item) => {
  //   this.setState({
  //     isShow: !this.state.isShow,
  //     activeItem: item || {},
  //   });
  // };
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };

    this.Speaker1 = [
       {
          imgUrl: icon1,
          desc: `<div>
        Aishwarya Jaishankar is the Co-founder and COO of Hyperface Technologies, Asia’s first Credit Card-as-a-Service platform for cobrands.
<br/><Br/>

Passionate about reimagining banking and money management, Aishwarya is known for challenging the status quo and building products that deliver 10X–100X impact. Her work spans pioneering Aadhaar OTP–based customer onboarding, leading a global bank’s digital overhaul, and now shaping next-generation credit card experiences at Hyperface.
<br/><Br/>

 A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.
<br/><br/>

Recognised among the Top 60 LinkedIn Voices in India Fintech by Favikon, her contributions have earned accolades such as Finnoviti, MMA Smarties, and the Mastercard Innovation Award. She has also been featured in industry lists including Top Women in Fintech, AWS BuildHer, and was shortlisted for Fintech Woman of the Year by BFF.
<br/><br/>

Aishwarya also serves on the Executive Committee of the India Fintech Forum, where she actively contributes to shaping the future of the fintech ecosystem. A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.


          
              </div>`,
          name: "Aishwarya Jaishankar",
          post: `<div>Co- Founder & COO<br/>
          Hyperface.co

          </div>`,
        },
       
 {
            imgUrl: icon2,
            desc: `<div>
       Nandika has a deep passion for building organizations while keeping the founder’s soul and vision at the center. Her expertise lies in translating organizational aspirations into execution realities by connecting people, strategy, and execution.  <br/><br/>
In her 15+ years of experience, Nandika has played various roles starting from being a consultant at Aon Hewitt, to leading multiple functional areas within HR globally at InMobi, to working alongside the founders driving business strategy, growth and operational excellence as part of InMobi's leadership team.<br/><br/>
At Fireside, she leads Strategy and People - She works on understanding where the consumer is headed, shaping the fund’s long-term outlook, and strengthening the organization for scale. She partners closely with portfolio companies across multiple growth vectors, helping them navigate their next stage of evolution. In her role, she also meets with multiple founders ahead of investments, understanding their vision, leadership approach, and potential to scale.<br/><br/>
Nandika holds an MBA from ISB Hyderabad and a BA (Honours) in Economics from LSR, Delhi University.

            </div>`,
            name: "Nandika Pradeep",
            post: `<div>Director, Strategy & Human Capital<br/>Fireside Ventures
 
     
            </div>`,
          },

      
      {
            imgUrl: icon3,
            desc: `<div>
 Sunitha Viswanathan is a Partner at Kae Capital. Prior to joining Kae Capital, she spent over 8 years with Unitus Ventures, a leading early-stage VC fund in Bangalore. At Unitus, she served on the boards of Cuemath, Masai School, Salesken, Awign, Blowhorn among others. Prior to Unitus Ventures, she worked with a technology startup in Bangalore. She has over a decade of experience spanning venture investment, banking and technology. Her experience also includes working with mid-market clients at Yes Bank. In addition to investing, Sunitha is also on the Board of Trustees of Mentor Together (India’s largest mentoring organisation for underprivileged children).
<Br/><br/>
Sunitha received her Bachelor’s degree in Electronics and Communications Engineering from PES Institute of Technology, Bangalore and a Master’s degree in Finance from S.P. Jain Institute of Management & Research, Mumbai. She has also cleared all 3 Levels of the program offered by the CFA Institute (USA).

 </div>`,
            name: "Sunitha Viswanathan",
            post: `<div>Partner<br/> Kae Capital
 
            </div>`,
          },
 
      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };

  

  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
     
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;

    return (
      <ContentPage>
      <Meta
      title="sheshines with Winpe"
      image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
      description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions!"
      location={location}
    />
      <div className="section__content" style={defaultStyle}>
     <div className="toastshine_wrapper">
     
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div> 
   
            <div className="toastshine_section">
        <h1 className="ignite-ask-me-anything__heading">sheshines with Winpe </h1>
        
           
        <hr className="ignite-ask-me-anything__hr"></hr>
        <div className="top_text">
        <b>she</b>shines with Winpe are in-person networking sessions for women in the investing and entrepreneurship ecosystem.
<br/><br/>

The importance of building strong networks cannot be underscored too much. The number of women in investing and entrepreneurship continues to be small and the imperative for everyone to know each other, support each other and leverage each other is that much stronger.
<br/><br/>

Through these events, Winpe attempts to bring women together to meet old friends and make new ones.
<br/><br/>

<b>she</b>shines events include interactive, candid and close-range discussions with senior women leaders and women champions from various fields and of course, lots of networking.
<br/><br/>

<b>she</b>shines will be in Mumbai, Bangalore & Delhi/Gurgaon every quarter.
<br/><br/>

              </div>
              <br />

              <br />
             

    
      
   
  <div className="tab_section container" style={{textAlign: 'center'}}>
   
  <ul class="nav nav-tabs justify-content-center" role="tablist" style={{display: "inline-block"}}>
  <li class="nav-item">
		<a class="nav-link  " data-toggle="tab" href="#tabs-3" role="tab" style={{padding: "10px 5px"}}>
      <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp; Mumbai&nbsp;  </h4> </a>
	</li>
	<li class="nav-item">
		<a class="nav-link   " data-toggle="tab" href="#tabs-1" role="tab" style={{padding: "10px 5px"}}> <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Delhi&nbsp;   </h4> </a>
	</li>
  <li class="nav-item">
		<a class="nav-link  active " data-toggle="tab" href="#tabs-2" role="tab" style={{padding: "10px 5px"}}> 
    <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Bangalore&nbsp;   </h4> </a>
	</li>
	
 
</ul> 
<div class="tab-content">
	<div class="tab-pane " id="tabs-1" role="tabpanel"><br/><br/> 
  
  <div className="eventlist_listing eventlist_listing_new">

  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>September 24, 2025 (5:00 PM - 8:00 PM IST)</h3>
                      
                  <h4> <i>Google office, Gurgaon
                  </i></h4>
                  <br/>
                            <strong>
                            AI as the New Co-Founder You Didn’t Know You Needed
                            </strong>
                            
          
              <br/>
                 <br/> 
                 <center>  
                 <a href="/sheshines24Sep2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
         
                          </div>
                      </div>
                    </div> 
                    
                   
                     <hr/><hr/>



  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>February 6, 2025 (5:00 PM - 8:00 PM IST)</h3>
                      
                  <h4> <i>Jaypee Vasant Continental, Vasant Vihar, New Delhi
                  </i></h4>
                 <br/> 
                 <center>  
                 <a href="/sheshines6Feb2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
        
              
                          </div>
                      </div>
                    </div>  <hr/><hr/>
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 7, 2024 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Navigating the Investor - Founder relationship

                            </strong>
                  
                  <h4> <i>Delhi NCR</i></h4>
                             
                  <center>  
                  <a href="/SheShines7Aug2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        
                       
                          <hr/><hr/>
              
                          </div>
                      </div>
                    </div>
    
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>January 24, 2024 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Networking works  

                            </strong>
                  
                  <h4> <i>Delhi NCR</i></h4>
                             
                  <br/> <br/>               

          <center>  
         <a href="/SheShines24Jan2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                         
             
                      

                          <hr/><hr/>
              
                          </div>
                      </div>
                    </div>
    
  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>July 27, 2023 (5:00 PM - 8:00 PM IST)</h3>
                  
                  <br/>
                            <strong>
                           Journeys: Women & Leadership 

                            </strong>
                            <h4> <i>JW Marriott, Aerocity, New Delhi</i></h4>
                           <br/> <br/>
                                   

<center>  
<a href="/sheshines27July2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
         
             
                      


              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>       
 
             
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 25, 2022 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Networking works  

                            </strong>
                  
                  <h4> <i>Hotel Andaz, Aerocity - Delhi</i></h4>
                             
                  <br/> <br/>               

          <center>  
         <a href="/SheShines25Aug2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
     
                          <hr/><hr/>
                          <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>       
                          </div>
                      </div>
                    </div>
       
            
  
              </div>        
                    
	</div>
  <div class="tab-pane active" id="tabs-2" role="tabpanel"><br/><br/> 
  
  <div className="eventlist_listing eventlist_listing_new">

<div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>December 11, 2025 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                           <br/>
                            <strong style={{fontSize:'16px'}}>
                         From Idea to Impact: What Investors Look For — The said and the unsaid 
                            </strong>
                            <h4><i>Bangalore International Centre</i></h4>
                          
             <br />  
                 <center>  
                  <a href="/sheshines11Dec2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        

                     
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  


  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>June 19, 2025 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                           <br/>
                            <strong style={{fontSize:'16px'}}>
                           The Founder-Investor Dance: Building High-Trust Relationships That Win

                            </strong>
                          
                            <h4> <i>  Bangalore
                            </i></h4>
                          
                         
            
              <br />  
                 <center>  
                  <a href="/sheshines19June2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        
         
              <center><h4>Hosted By:</h4> 
              <img src={"https://winpeforum.com/assets/elements/epicworld-removebg-preview.png"} style={{width:'100px'}}/>
              </center>
              <br/>
                     
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 28, 2024 (4:00 - 7:00 PM IST)</h3>
                           <br/>
                            
                          
                            <h4> <i> Wink, Vivanta, Bengaluru
                            </i></h4>
                          
                         
            
              <br />  
              <center>  
                  <a href="/Sheshines28Nov2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        
                       
 
              <center><h4>In collaboration with:</h4> 
              <img src={"https://winpeforum.com/assets/elements/vivanta.png"} style={{width:'400px'}}/>
              </center>
              <br/><br/>
             
                 
        

           
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>May 23, 2024 (5:00 - 8:00 PM IST)</h3>
                          
                            <h4>
                         <i>  Bangalore International Centre</i> 
                            </h4>
                           
<br/>
<center>  
         <a href="/SheShines23May2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 

<br/>
                 

                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>             
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 24, 2023 (5:00 PM - 8:00 PM IST)</h3>
                  
                         
                        <br/>
                        <h4> <i>Bangalore International Centre </i></h4>
                             

     
<br/>
  
<center>  
         <a href="/SheShines24Aug2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
     
                         
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>
               
               
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>January 19, 2023 (4:00 PM - 7:00 PM IST)</h3>
                  <br/>
                            <strong>
                             Journeys: Women & Leadership 

                            </strong>
                  
                  <h4> <i>Jook Taproom, Indiranagar, Bangalore</i></h4>
                            <br/><br/>
                            <center>  
         <a href="/SheShines19Jan2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 

  
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>

  
              </div> 



  <div className="eventlist_listing eventlist_listing_new">
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>June 30, 2022 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Networking Works: Leveraging Networks for Growth and Success 

                            </strong>
                  
                  <h4> <i>Kazé, Bangalore</i></h4>
                            <br/><br/>
                    
                          <center>  
         <a href="/SheShines30June2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                 
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>

  
              </div>        
                    
	</div>
	<div class="tab-pane     " id="tabs-3" role="tabpanel"><br/><br/> 
 
  <div className="eventlist_listing eventlist_listing_new">
    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 6, 2025 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            
                            <strong>
                       Up Close with A91 Partners: Building a differentiated investment firm
                            </strong>
                            <h4> <i> A91 Partners Office, Mumbai
                            </i></h4>
                         
            
              <br />  
              
                 <center><h4>Hosted By:</h4> <br/>
          <img src={"https://winpeforum.com/assets/elements/A91_Final.jpeg"} style={{width:'60px'}}/>  
</center>        
   <center>  
              <a href="/sheshines06Nov2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center>
                        </div>
                      </div>
                    </div> 

  


                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>October 17, 2024 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            
                          
                            <h4> <i> Motilal Oswal Tower, Prabhadevi, Mumbai
                            </i></h4>
                          
                          <h4>Hosted by: Motilal Oswal</h4>
            
              <br />  
              <center>  
              <a href="/SheShines17Oct2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
 
                    

                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>October 13, 2023 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            <strong>
                            The Role of Self
                            </strong>
                          
                            <h4> <i> A91 Partners, Mumbai </i></h4>
                            <br/> 
                          
            
              <br />  
          
<center>  
<a href="/sheshines13Oct2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
               

                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>            
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 10, 2022 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            <strong>
                            Journey's: Women & Leadership
                            </strong>
                          
                            <h4> <i>The Quorum Club, LowerParel, Mumbai</i></h4>
                            <br/><br/>
                          <center>  
         <a href="/SheShines10Nov2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>April 21, 2022 (4:30 PM IST)</h3>
                           <br/>
                            <strong>
                            Networking works
                            </strong>
                          
                            <h4> <i>The Quorum Club, LowerParel, Mumbai</i></h4>
                            <br/><br/>
                          <center>  
         <a href="/SheShinesWithWinPE/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
              
                        </div>
                      </div>
                    </div>
                    <hr/><hr/>
                   
                    </div>
 
 
 
 
 </div>
	</div>
 
</div>
        
<br/>    <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  
<br /><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/> <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>   <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/> <br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/>       <br/> <br/>        <br/> <br/>        <br/> <br/>       
</div>
                <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
      </div></div>
      </ContentPage>
    );
  }
}




WinPEEdge.propTypes = {
  location: PropTypes.object,
};

export default WinPEEdge;
 


// WEBPACK FOOTER //
// ./src/pages/SheShines/index.js